// App.js
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import GLightbox from "glightbox";
import "glightbox/dist/css/glightbox.css";
import { useEffect, useState } from "react";
import "swiper/css";
import "swiper/css/pagination";
import "./assets/css/main.css";

import RouteFile from "./Routes/routeFile";
import TerrainFogScene from "./animation";
import ScrollToTop from "./components/Common/ScrollToTop";

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    // Initialize AOS and GLightbox
    AOS.init({ duration: 1000, once: true });
    GLightbox({ selector: ".glightbox" });

    // Start fade out after 800ms
    const fadeTimer = setTimeout(() => {
      setIsLoading(false);
    }, 800);

    // Completely hide loader after fade transition
    const hideTimer = setTimeout(() => {
      setShowLoader(false);
    }, 1200); // 800ms + 400ms fade transition

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(hideTimer);
    };
  }, []);

  return (
    <div className="index-page">
      {/* Loading Screen */}
      {showLoader && (
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            zIndex: 9999,
            opacity: isLoading ? 1 : 0,
            transition: 'opacity 0.4s ease-out',
            pointerEvents: isLoading ? 'auto' : 'none'
          }}
        >
          <TerrainFogScene />
        </div>
      )}

      {/* Main App Content */}
      <div 
        style={{
          opacity: isLoading ? 0 : 1,
          transition: 'opacity 0.4s ease-in',
          transitionDelay: isLoading ? '0s' : '0.2s'
        }}
      >
        <ScrollToTop />
        <RouteFile />
      </div>
    </div>
  );
}

export default App;